import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./css/style.css";
import "./css/login.css";
import "react-toastify/dist/ReactToastify.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "sweetalert2/dist/sweetalert2.css";
import { Switch, Route, HashRouter } from "react-router-dom";
import Login from "./login";
import Register from "./register";
import ForgotPassword from "./forgotpassword";
ReactDOM.render(
  <HashRouter>
    <Switch>
      <Route exact path="/" component={Login} />
      <Route path="/home" component={App} />
      <Route path="/dashboard" component={App} />
      <Route path="/directsponsor" component={App} />
      <Route path="/teamlist" component={App} />
      <Route path="/treeview" component={App} />
      <Route exact path="/transfer" component={App} />
      <Route exact path="/transfer/:pinid/:pinpass" component={App} />
      <Route exact path="/treeview/:treeid" component={App} />
      <Route exact path="/invoice" component={App} />
      <Route exact path="/invoicedetail/:billno" component={App} />
      <Route path="/buypackage" component={App} />
      <Route path="/activation" component={App} />
      <Route path="/cwallet" component={App} />
      <Route path="/teamsales" component={App} />
      <Route path="/paidsummary" component={App} />
      <Route path="/joiningbonus" component={App} />
      <Route path="/purchasehistory" component={App} />
      
      <Route path="/kyc/bank" component={App} />
      <Route path="/transactions/:type" component={App} />
      <Route path="/ewallet" component={App} />
      <Route path="/kyc/pan" component={App} />
      <Route path="/kyc/aadhar" component={App} />
      <Route path="/profile" component={App} />
      <Route path="/changepassword" component={App} />
      <Route path="/pintransferhistory" component={App} />
      <Route path="/repurchaseincome" component={App} />
      <Route path="/epin" component={App} />
      <Route path="/changepassword/:step" component={App} />
      <Route path="/login" component={Login} />
      <Route exact path="/jbonusreport" component={App} />
      <Route exact path="/jbonusreport/:cdate" component={App} />
      <Route exact path="/register" component={Register} />
      <Route exact path="/register/:ref" component={Register} />
      <Route exact path="/register/:ref/:pinid/:pinpass" component={Register} />
      <Route exact path="/upgrade" component={App} />
      <Route path="/forgotpassword" component={ForgotPassword} />
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);
